import * as React from "react";
import {useEffect} from "react";
import {useAppSelector} from "../../../app/hooks";
import {useTranslation} from "react-i18next";
import {LanguageEnum} from "../../../enum/language";
import {RecoveryStepEnum} from "../../../enum/auth";
import {RecoveryPhoneCode} from "./RecoveryPhoneCode";
import {CreateNewPassword} from "./CreateNewPassword";
import {NoAccountAccess} from "./NoAccountAccess";
import {RecoveryCodeOutdated} from "./RecoveryCodeOutdated";
import {PasswordRecovery} from "./PasswordRecovery";
import {LocalStorageEnum} from "../../../enum/localStorage";
import {RecoveryAccount} from "./RecoveryAccount";

export const Recovery = () => {

    const {i18n} = useTranslation();
    const {recoveryStep} = useAppSelector(state => state.auth)

    useEffect(() => {
        const item = localStorage.getItem(LocalStorageEnum.lang)
        switch (item) {
            case (LanguageEnum.Ru) : {
                i18n.changeLanguage(LanguageEnum.Ru)
                return
            }
            case (LanguageEnum.En) : {
                i18n.changeLanguage(LanguageEnum.En)
                return
            }
            default : {
                localStorage.setItem(LocalStorageEnum.lang, LanguageEnum.Ru)
                return;
            }
        }
    }, [])

    const router = () => {

        switch (recoveryStep) {

            case RecoveryStepEnum.RecoveryPhoneCode :
                return <RecoveryPhoneCode/>
            case RecoveryStepEnum.CreateNewPassword:
                return <CreateNewPassword/>
            case RecoveryStepEnum.PasswordSaving:
                return <CreateNewPassword/>
            case RecoveryStepEnum.NoAccountAccess:
                return <NoAccountAccess/>
            case RecoveryStepEnum.RecoveryCodeOutdated:
                return <RecoveryCodeOutdated/>
            case RecoveryStepEnum.RecoveryAccount:
                return <RecoveryAccount/>
            case RecoveryStepEnum.Recovery :
            default :
                return <PasswordRecovery/>
        }
    }

    return <div className={'background body1'}>
        <>{router()}</>
    </div>
}
export default Recovery
